
import {IElement, ITextAttributes, ITextSelectionInformation} from 'routes/private/Editor/types';
import {IFontSizeValue} from 'routes/private/Editor/Editor/CommandsBars/TextCommandBar/CommandsOptions/FontSizeCommandOption/types';
import { useSelector } from 'react-redux';
import selectors from '@state/selectors';
import { execCommandToSelectedText, updateRenderingTextSegments } from 'utils/textMultiStyling'

export const fontSizeResolver = ( element: IElement, value: IFontSizeValue , textSelectionInformation?: ITextSelectionInformation ) => {
    if (element.type === "Text") {
        const attributes = execCommandToSelectedText("fontSize", (element.attributes as ITextAttributes), textSelectionInformation, value);
        element.attributes = updateRenderingTextSegments(attributes);
    }
    return element;
}